// src/Pages/OrderDetails.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import SEO from "../Components/SEO";

export default function OrderDetails() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadOrder = async () => {
      try {
        const ref = doc(db, "orders", orderId);
        const snap = await getDoc(ref);

        if (snap.exists()) {
          setOrder({ id: snap.id, ...snap.data() });
        }
      } catch (err) {
        console.error("Error loading order:", err);
      } finally {
        setLoading(false);
      }
    };

    loadOrder();
  }, [orderId]);

  if (loading)
    return (
      <main style={{ textAlign: "center", padding: 40 }}>Loading order...</main>
    );

  if (!order)
    return (
      <main style={{ textAlign: "center", padding: 40 }}>
        <h2>Order not found</h2>
      </main>
    );

  const shipping = order.shippingInfo || {};

  return (
    <main style={{ maxWidth: 800, margin: "0 auto", padding: "40px 20px" }}>
      <SEO title={`Order #${order.id.slice(-6)}`} />

      <h1>Order #{order.id.slice(-6)}</h1>

      <p style={{ color: "#555", marginTop: 8 }}>
        <strong>Status:</strong> {order.status}
      </p>

      <p style={{ color: "#555", marginTop: 8 }}>
        <strong>Date:</strong>{" "}
        {order.createdAt?.toDate
          ? order.createdAt.toDate().toLocaleString()
          : "—"}
      </p>

      {/* 🔥 TRACKING INFO SECTION (Only appears if trackingNumber exists) */}
      {order.trackingNumber && (
        <div
          style={{
            marginTop: 25,
            padding: "20px",
            border: "1px solid #c3e6cb",
            backgroundColor: "#d4edda", // Light green background
            borderRadius: "8px",
            color: "#155724",
          }}
        >
          <h3 style={{ margin: "0 0 10px 0", fontSize: "1.2rem" }}>
            📦 Shipment on the way
          </h3>
          <p style={{ margin: "5px 0" }}>
            <strong>Tracking Number:</strong> {order.trackingNumber}
          </p>
          <a
            href={`https://parcelsapp.com/en/tracking/${order.trackingNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontWeight: "bold",
              color: "#155724",
              textDecoration: "underline",
            }}
          >
            Track your package here
          </a>
        </div>
      )}

      {/* SHIPPING INFO */}
      <h2 style={{ marginTop: 30 }}>Shipping Details</h2>

      <p>{shipping.fullName}</p>
      <p>
        {shipping.address}, {shipping.city}
      </p>
      <p>{shipping.postalCode}</p>
      {shipping.phone && <p>Phone: {shipping.phone}</p>}
      {shipping.notes && <p>Notes: {shipping.notes}</p>}

      {/* ITEMS */}
      <h2 style={{ marginTop: 30 }}>Items</h2>

      <ul style={{ paddingLeft: 20 }}>
        {order.items?.map((item, i) => (
          <li key={i} style={{ marginBottom: 6 }}>
            {item.quantity} × {item.name}
          </li>
        ))}
      </ul>

      <p style={{ marginTop: 20, fontSize: "1.1rem" }}>
        <strong>Total: </strong>${order.total?.toFixed(2)}
      </p>

      <Link
        to="/my-orders"
        style={{
          display: "inline-block",
          marginTop: 30,
          padding: "10px 20px",
          borderRadius: 8,
          background: "#333",
          color: "#fff",
          textDecoration: "none",
        }}
      >
        Back to My Orders
      </Link>
    </main>
  );
}